import { item, type NavItem } from "./navigation-item";

/** The settings screens of the sellable modules: money, directories, sales, hiring, documents,
 * therapy, billing. */
export const SETTINGS_NAVIGATION_MODULES: readonly NavItem[] = [
  item(
    "therapy-cpt-codes",
    "Interventions",
    "/settings/therapy-cpt-codes",
    "care",
    "therapy:manage",
    {
      surface: "settings",
      scope: "shared",
      settingsCategory: "Therapies",
    },
  ),
  item(
    "therapy-note-templates",
    "Note templates",
    "/settings/therapy-note-templates",
    "care",
    "therapy:manage",
    {
      surface: "settings",
      scope: "shared",
      settingsCategory: "Therapies",
    },
  ),
  item(
    "therapy-vendors",
    "Therapy vendors",
    "/settings/therapy-vendors",
    "care",
    "therapy:manage",
    {
      surface: "settings",
      scope: "organization",
      settingsCategory: "Therapies",
    },
  ),
  item("crm-lead-fields", "Lead fields", "/settings/lead-fields", "crm", "crm:manage", {
    surface: "settings",
    scope: "shared",
    settingsCategory: "Marketing & CRM",
  }),
  item("crm-email-templates", "Email templates", "/settings/email-templates", "crm", "crm:manage", {
    surface: "settings",
    scope: "facility",
    settingsCategory: "Marketing & CRM",
  }),
  item(
    "crm-website-lead-sources",
    "Website lead sources",
    "/settings/website-lead-sources",
    "crm",
    "crm:manage",
    {
      surface: "settings",
      scope: "facility",
      settingsCategory: "Marketing & CRM",
    },
  ),
  /* Her rendered instruction and a test chat, opened from her settings: a tool, not a setting. */
  item(
    "shelby-agent",
    "Sales assistant agent",
    "/shelby/agent",
    "sales-assistant",
    "salesagent:manage",
    {
      surface: "hidden",
    },
  ),
  item(
    "shelby-settings",
    "Sales assistant",
    "/shelby/settings",
    "sales-assistant",
    "salesagent:manage",
    { surface: "settings", scope: "facility", settingsCategory: "Sales assistant" },
  ),
  item(
    "medicaid-rates",
    "Medicaid rates",
    "/settings/medicaid-rates",
    "financials",
    "financial:manage",
    {
      surface: "settings",
      scope: "shared",
      settingsCategory: "Financials",
    },
  ),
  item(
    "ats-message-templates",
    "Candidate message templates",
    "/settings/ats-message-templates",
    "workforce",
    "hiring:manage",
    {
      surface: "settings",
      scope: "facility",
      settingsCategory: "Workforce",
    },
  ),
  item(
    "ats-offer-templates",
    "Offer templates",
    "/settings/ats-offer-templates",
    "workforce",
    "hiring:manage",
    {
      surface: "settings",
      scope: "facility",
      settingsCategory: "Workforce",
    },
  ),
  item("providers", "Provider directory", "/providers", "care", "directory:read", {
    surface: "settings",
    scope: "shared",
    settingsCategory: "Directories",
  }),
  item("pharmacies", "Pharmacy directory", "/pharmacies", "care", "directory:read", {
    surface: "settings",
    scope: "shared",
    settingsCategory: "Directories",
  }),
  item("institutions", "Institutions directory", "/institutions", "care", "directory:read", {
    surface: "settings",
    scope: "shared",
    settingsCategory: "Directories",
  }),
  item(
    "document-types",
    "Document types",
    "/settings/document-types",
    "administration",
    "settings:read",
    {
      surface: "settings",
      scope: "shared",
      settingsCategory: "Documents",
    },
  ),
  item(
    "document-templates",
    "Document templates",
    "/settings/document-templates",
    "administration",
    "settings:read",
    {
      surface: "settings",
      scope: "shared",
      settingsCategory: "Documents",
    },
  ),
  item(
    "admission-forms",
    "Move-in packets",
    "/settings/move-in",
    "administration",
    "admission:manage",
    {
      surface: "settings",
      scope: "facility",
      settingsCategory: "Documents",
    },
  ),
  item(
    "plans-modules",
    "Plans & modules",
    "/settings/plans-modules",
    "administration",
    "platform:read",
    {
      surface: "settings",
      scope: "platform",
      settingsCategory: "Billing & plan",
      platformOnly: true,
    },
  ),
  item(
    "online-payments",
    "Online payments",
    "/settings/payments",
    "financials",
    "financial:manage",
    {
      surface: "settings",
      scope: "facility",
      settingsCategory: "Financials",
    },
  ),
  item(
    "qb-mappings",
    "QB account mappings",
    "/settings/qb-mappings",
    "financials",
    "financial:manage",
    {
      surface: "settings",
      scope: "inherited",
      settingsCategory: "Financials",
    },
  ),
  item(
    "transaction-tags",
    "Transaction tags",
    "/settings/transaction-tags",
    "financials",
    "financial:manage",
    {
      surface: "settings",
      scope: "organization",
      settingsCategory: "Financials",
    },
  ),
  item(
    "expense-categories",
    "Expense categories",
    "/settings/expense-categories",
    "financials",
    "financial:manage",
    {
      surface: "settings",
      scope: "organization",
      settingsCategory: "Financials",
    },
  ),
];
